import { get } from "lodash";
import InputFieldSet from "PFComponents/text/input_field_set";
import { Typography } from "PFComponents/typography";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SkillsFrameworkData } from "../../../skills_frameworks.types";
import pageCss from "../../skills_frameworks_edit_page.module.scss";

export const DescriptionSection = () => {
  const { t } = useTranslation("skillsFrameworks", { keyPrefix: "edit" });
  const {
    control,
    formState: { errors }
  } = useFormContext<SkillsFrameworkData>();

  return (
    <>
      <Typography variant="h4" className={pageCss.sectionTitle}>
        {t("description")}
      </Typography>
      <Controller
        name="description"
        control={control}
        render={({ field: { name, onChange, value } }) => (
          <InputFieldSet
            value={value}
            kind="bordered"
            error={get(errors, name)?.message}
            handleChange={onChange}
            maxLength={400}
          />
        )}
      />
    </>
  );
};
